import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';

const Cookies = () => (
  <LegalLayout
    eyebrow="Legal"
    title="Cookie Notice"
    lead="The short version: I don't track you. Here's the detail."
  >
    <p className="legal-meta">Last updated: 3 June 2026</p>

    <h2>Do I use cookies?</h2>
    <p>
      Cookies are small files a website can store in your browser. This site does{' '}
      <strong>not</strong> use advertising, analytics or tracking cookies, and I don't build a
      profile of your visit. There's no consent banner because I don't set the kind of cookies that
      require one.
    </p>

    <h2>What may still be stored</h2>
    <ul>
      <li>
        <strong>Essential technical data</strong> — your browser and my hosting provider may use
        small amounts of storage purely to load and secure the site. These aren't used to track you
        across the web.
      </li>
      <li>
        <strong>Google Fonts</strong> — the site loads fonts from Google's servers, which means
        your browser contacts Google when a page loads. This transmits your IP address to Google but
        does not place tracking cookies from me. See the{' '}
        <Link to="/privacy">privacy policy</Link> for more on this.
      </li>
    </ul>

    <h2>Controlling cookies</h2>
    <p>
      You're always in control. Every major browser lets you view, block or delete cookies and site
      data from its settings. Blocking storage won't break this site, since it doesn't rely on
      tracking to work.
    </p>

    <h2>Changes</h2>
    <p>
      If I ever start using cookies that require your consent, I'll update this notice and ask for
      your permission first.
    </p>

    <h2>Contact</h2>
    <p>
      Questions? Email{' '}
      <a href="mailto:contact@isurugimhan.com">contact@isurugimhan.com</a>.<br />
      Isuru Gimhan · Kalutara, Sri Lanka.
    </p>
  </LegalLayout>
);

export default Cookies;
